import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import _ from 'lodash';
import {
    AGENT_SOFTWARE_VERSION_FIELD,
    AGENT_STATUS_FIELD,
    AGENT_VITALS_TX_BUDGET_USED,
    AGENT_WIFI_SIGNAL_LEVEL_FIELD,
    AGENT_WIFI_SSID_FIELD,
    DBM,
} from './AgentConstants';
import { renderStatus, renderVersion, renderWifiSSID, renderTxBudget } from './AgentRenderHelper';
import { defaultColumnMapper } from '../../data-table/DataTableColumns';
import { softwareVersionMapper } from './AgentVersionHelper';
import { hasTxBudget, isRunning } from './AgentHelper';

export const STATUS_LABEL_TEXT = i18n._(t`Status`);
export const MODEL_LABEL_TEXT = i18n._(t`Model`);
export const VERSION_LABEL_TEXT = i18n._(t`Version`);
export const WIFI_LABEL_TEXT = i18n._(t`Wi-Fi Network`);
export const WIFI_ERRORS_LABEL_TEXT = i18n._(t`Wi-Fi Connection Errors`);
export const TX_BUDGET_LABEL_TEXT = i18n._(t`Transmit Budget Used`);

const wifiNotConfiguredText = i18n._(t`Wi-Fi network not assigned`);
const virturalWifiNotConfiguredText = i18n._(t`Wi-Fi network not connected`);

export function renderWiFiData(columnClasses, agent, isHardwareAgent, isVirtualAgentWiFi) {
    if (!isHardwareAgent && !isVirtualAgentWiFi) {
        return null;
    }

    if (isHardwareAgent && _.isEmpty(_.get(agent, AGENT_WIFI_SSID_FIELD))) {
        return <div>{wifiNotConfiguredText}</div>;
    }

    if (isVirtualAgentWiFi && _.isEmpty(_.get(agent, AGENT_WIFI_SSID_FIELD))) {
        return <div>{virturalWifiNotConfiguredText}</div>;
    }

    return (
        <div className={columnClasses.root}>
            {(isHardwareAgent || isVirtualAgentWiFi) &&
                renderWifiSSID(agent, {
                    mapper: () => {
                        const wifiSignalLevel = _.get(agent, AGENT_WIFI_SIGNAL_LEVEL_FIELD);
                        const wifiSignalLevelFmt = wifiSignalLevel ? ` (${wifiSignalLevel} ${DBM}) ` : '';
                        return `${_.get(agent, AGENT_WIFI_SSID_FIELD)}${wifiSignalLevelFmt}`;
                    },
                })}
        </div>
    );
}

export function renderTxBudgetData(columnClasses, agent, isGlobalAgent) {
    if (!(isGlobalAgent && isRunning(agent) && hasTxBudget(agent))) {
        return null;
    }

    return (
        <div className={columnClasses.root}>
            {renderTxBudget(agent, {
                mapping: AGENT_VITALS_TX_BUDGET_USED,
                mapper: defaultColumnMapper,
            })}
        </div>
    );
}

export function renderStatusData(columnClasses, agent) {
    return (
        <div className={columnClasses.root}>
            {renderStatus(agent, {
                mapping: AGENT_STATUS_FIELD,
                mapper: defaultColumnMapper,
            })}
        </div>
    );
}

export function renderVersionData(columnClasses, agent) {
    return (
        <div className={columnClasses.root}>
            {renderVersion(agent, {
                mapping: AGENT_SOFTWARE_VERSION_FIELD,
                mapper: softwareVersionMapper,
                renderer: renderVersion,
            })}
        </div>
    );
}
